package com.isaias.fyattravel.web.layout
 
import org.jetbrains.compose.web.css.*
import com.isaias.fyattravel.web.theme.ThemeColors
 
object ResponsiveStyles : StyleSheet() {
    val rootMobileColumn by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                flexDirection(FlexDirection.Column)
            }
        }
    }
 
    val sidebarTopBar by style {
        display(DisplayStyle.None)
        width(100.percent)
        padding(0.9.em, 1.em)
        backgroundColor(ThemeColors.surface)
        property("border-bottom", "1px solid ${ThemeColors.divider}")
        cursor("pointer")
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        position(Position.Sticky)
        top(0.px)
        property("z-index", "30")
        media(mediaMaxWidth(760.px)) {
            self style {
                display(DisplayStyle.Flex)
            }
        }
    }
 
    val sidebarDesktop by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                display(DisplayStyle.None)
            }
        }
    }
 
    val footerHideOnMobile by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                display(DisplayStyle.None)
            }
        }
    }
 
    val footerGrid by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                gridTemplateColumns("1fr 1fr")
                gap(0.9.em)
            }
        }
        media(mediaMaxWidth(420.px)) {
            self style {
                gridTemplateColumns("1fr")
            }
        }
    }
 
    val footerContactCol by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.FlexEnd)
        media(mediaMaxWidth(760.px)) {
            self style {
                display(DisplayStyle.None)
            }
        }
    }
 
    val formStackMobile by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                gridTemplateColumns("1fr")
            }
        }
    }
 
    val flightSearchGrid by style {
        gridTemplateColumns("1fr 1fr 1fr 1fr 1fr auto")
        media(mediaMaxWidth(760.px)) {
            self style { gridTemplateColumns("1fr") }
        }
    }

    val hotelSearchGrid by style {
        gridTemplateColumns("1.4fr 1fr 1fr 0.7fr 0.7fr 1fr auto")
        media(mediaMaxWidth(1024.px)) {
            self style { gridTemplateColumns("1fr 1fr") }
        }
        media(mediaMaxWidth(760.px)) {
            self style { gridTemplateColumns("1fr") }
        }
    }
 
    val carSearchGrid by style {
        gridTemplateColumns("1.2fr 1.2fr 1fr 1fr 0.8fr 0.8fr 0.7fr auto")
        media(mediaMaxWidth(1024.px)) {
            self style { gridTemplateColumns("1fr 1fr") }
        }
        media(mediaMaxWidth(760.px)) {
            self style { gridTemplateColumns("1fr") }
        }
    }
 
    val twoColStackMobile by style {
        gridTemplateColumns("1fr 1fr")
        media(mediaMaxWidth(760.px)) {
            self style { gridTemplateColumns("1fr") }
        }
    }
 
    val buttonFullMobile by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                width(100.percent)
            }
        }
    }
 
    val flightCardCompact by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                padding(0.9.em)
            }
        }
    }
 
    val flightCardHeaderCompact by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                marginBottom(0.6.em)
            }
        }
    }
 
    val flightRouteCompact by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                padding(0.6.em)
            }
        }
    }
 
    val flightRouteTextCompact by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                fontSize(1.2.em)
            }
        }
    }
 
    val flightActionsCompact by style {
        media(mediaMaxWidth(760.px)) {
            self style {
                flexDirection(FlexDirection.Column)
                gap(0.5.em)
                alignItems(AlignItems.Stretch)
            }
        }
    }
}
